import React from "react";

const SvgComponent = ({ ...props }) => {
  const { iconSize, iconColor, className } = props;
  return (
    <svg stroke={iconColor || 'currentColor'} fill={iconColor || 'currentColor'} strokeWidth="0" viewBox="0 0 512 512" height={iconSize || '1em'} width={iconSize || '1em'} xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"></path>
    </svg>
  );
};

export default SvgComponent;
